import { Api } from './index'
import VueCookie from 'vue-cookie'

const appkey = window.x2.authsrv ? encodeURIComponent(window.x2.authsrv.appkey) : '';

//const base = 'http://' + window.x2.authsrv.host + ':' + window.x2.authsrv.port
const base = ""

export function authByLoginPassword (login, password) {
      let data = {}
      data['login'] = login
      data['passwd'] = password
      data['session'] = {}
      return Api.post(`${base}/auth?appkey=${appkey}`, data, { withCredentials: false }).then(response => {
        if (response.data.sid) {
          VueCookie.set('X1_SSO', response.data.sid)
        }
        return Promise.resolve(response)
      }).catch(e => {
        return Promise.reject(new Error(e.data))
      })

}

export function authBySso () {
  const sso = VueCookie.get('X1_SSO')
  return Api.post('/session/get?appkey=' + window.x2.authsrv.appkey, {sid: sso, membership: 1}).then(response => {
    let userdata = {
      username: response.data.data.login,
      role: []
    }
    if (response.data.data.membership) {
      response.data.data.membership.map(item => { userdata.role.push(item.groupfk) })
    }
    return Promise.resolve(userdata)
  }).catch(error => {
    return Promise.reject(new Error(error.data))
  })
}

export function createUser (login, password, email = null, confirm = false) {
  let data = {
    login: login,
    x_passwd: password
  }
  if (email) {
    data['email'] = email
  }
  if (confirm) {
    data['confirm'] = true
  }
  return Api.post('/user/register?appkey=' + window.x2.authsrv.appkey, data)
}

